const DUMMY_PROJECTS = [
    {
        projectTitle: 'Online Quiz and Exam System',
        description: 'A web-based platform where teachers can create and manage quizzes and exams, and students can take tests, view results, and receive feedback. Built using HTML, CSS, JavaScript, and JSON Server for backend functionality.',
        sourceLink: 'https://github.com/emmanuelronoh/Online-Quiz-and-Exam-System.git',
        lastUpdated: 'Nov 20 2024'
    },
    {
        projectTitle: 'Zenmax Online Shopping Platform',
        description: 'An e-commerce web application offering a seamless shopping experience with product search, filtering, user authentication, and CRUD operations. Developed with React, deployed on Render.',
        sourceLink: 'https://github.com/emmanuelronoh/Zen-max_ecommerce.git',
        lastUpdated: 'Oct 15 2024'
    },
    {
        projectTitle: 'Note-Taking Web App',
        description: 'A professional-looking note-taking application that allows users to create, edit, and manage notes efficiently. Features a clean UI with dark mode support. Built using React and Flask.',
        sourceLink: 'https://github.com/emmanuelronoh/notes-taking-app-full-stack.git',
        lastUpdated: 'Aug 10 2024'
    },
    {
        projectTitle: 'Moringa School Daily.dev',
        description: 'A platform providing software engineering students with authentic content like videos, audio, and blogs created by the Moringa School community. It includes features such as user management, content creation, and personalized recommendations for enhanced learning and interaction.',
        sourceLink: 'https://github.com/emmanuelronoh/Moringa-daily-dev-project.git',
        lastUpdated: 'Jul 28 2024'
    },
    {
        projectTitle: 'Personal Finance Tracker',
        description: 'A personal finance management application that helps users track income and expenses, set budgets, and analyze spending habits. The application includes user authentication, transaction management, budget tracking, and expense analysis to provide a complete solution for personal finance management.',
        sourceLink: 'https://github.com/emmanuelronoh/personal-finance-tracker.git',
        lastUpdated: 'Jul 28 2024'
    }
    
];

const ProjectsData = { DUMMY_PROJECTS };
export default ProjectsData;
